<template>
  <div class="login">
    <mymenu />
    <div class="login-con">
      <img
        src="../../assets/images/loginbg.jpg"
        width="100%"
        height="100%"
        alt=""
      />
      <!-- {{ model }} -->
      <div class="register-form">
        <div class="register-inner">
          <h3 class="forget_center">重置密码</h3>

          <div class="input">
            <el-input
              placeholder="请输入注册手机号"
              v-model="model.mobile"
              clearable
              :modal="false"
              style="margin-top: 10px"
            >
            </el-input>
            <p class="input-text">如果手机已停用,请使用备用手机号验证</p>
          </div>
          <!-- <div class="input clearfix">
            <div class="fl">
              <el-input
                placeholder="请输入图片验证码"
                v-model="model.captcha"
                clearable
              >
              </el-input>
            </div>
            <div class="fr">
              <img @click="getCapt()" class="codeImg" :src="url" alt="" />
            </div>
          </div> -->
          <div class="input clearfix">
            <div class="fl">
              <el-input
                placeholder="请输入验证码"
                v-model="model.captcha"
                clearable
              >
              </el-input>
            </div>
            <div class="fr">
              <el-button class="get-imgcode" @click="getResetPassWordCode()"
                >获取验证码</el-button
              >
            </div>
          </div>
          <div class="input">
            <el-input
              show-password
              placeholder="请设置密码"
              v-model="model.newpassword"
              clearable
            >
            </el-input>
          </div>
          <div class="input">
            <el-input
              show-password
              placeholder="请确认密码"
              v-model="model.repassword"
              clearable
            >
            </el-input>
          </div>
          <div class="forget_center">
            <el-button class="next-btn" @click="resetPassWord()"
              >重置密码</el-button
            >
            <el-button class="next-btn" @click="goLogin()">返回登录</el-button>
          </div>
        </div>
      </div>
      <applyBottom></applyBottom>
    </div>
  </div>
</template>

<script>
import { getCapt, getCode, reqResetPassword } from "@/api";
import { erroralert, successalert } from "@/utils/alert";
export default {
  data() {
    return {
      url: "",
      model: {
        mobile: "",
        captcha: "",
        captcha_key: "",
        code: "",
        event: "resetpwd",
        newpassword: "",
        repassword: "",
      },
    };
  },
  created() {
    let that = this;
    // that.getCapt();
  },
  methods: {
    //获取图片验证码
    getCapt() {
      getCapt().then((res) => {
        if (res.data.code == 1) {
          this.url = res.data.data.captcha;
          this.model.captcha_key = res.data.data.key;
        }
      });
    },
    getResetPassWordCode() {
      let that = this;
      getCode(that.model).then((res) => {
        if (res.data.code == 1) {
          successalert(res.data.msg);
        }
      });
    },
    goLogin() {
      let that = this;
      that.$router.push("/login");
    },
    //重置密码
    resetPassWord() {
      let that = this;
      that.checkUserPassWord().then(() => {
        reqResetPassword(that.model).then((res) => {
          if (res.data.code === 1) {
            successalert(res.data.msg);
            that.$router.push("/login");
          } else {
            erroralert(res.data.msg);
          }
        });
      });
    },
    //验证用户重置密码
    checkUserPassWord() {
      let that = this;
      return new Promise((resolve) => {
        if (that.model.mobile === "") {
          erroralert("请输入手机号");
          return;
        }

        if (that.model.captcha === "") {
          erroralert("请输入验证码");
          return;
        }

        if (that.model.newpassword === "") {
          erroralert("请输入密码");
          return;
        }

        if (that.model.repassword === "") {
          erroralert("请输入确认密码");
          return;
        }

        if (that.model.newpassword !== that.model.repassword) {
          erroralert("二次密码输入不一致");
          return;
        }
        resolve();
      });
    },
  },
};
</script>

<style scoped>
.forget_center {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}
</style>
